/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceFilterResponse {
    getFixupPrototypeFunction() { return ComplianceFilterResponse.fixupPrototype; }

    static newInstance(model: Partial<ComplianceFilterResponse>): ComplianceFilterResponse {
        let obj = Object.assign(new ComplianceFilterResponse(), model);
        ComplianceFilterResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceFilterResponse>): ComplianceFilterResponse {
        if (!model) return null;
        return ComplianceFilterResponse.newInstance(<ComplianceFilterResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceFilterResponse) {
        if (!obj) return;

        models.ComplianceFilterResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceFilterResponse): boolean {
        Object.setPrototypeOf(obj, ComplianceFilterResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.tenants) {
            models.ComplianceStandard.fixupPrototype(this.tenants);
        }
    }

    /**
     * Tenants data for compliance posture filters
     */
    tenants: models.ComplianceStandard;

}
